module.exports = __webpack_public_path__ + "img/advantage6Orange.2e49ac7e.png";